/**
 * نشانگر مرحله‌ی خط لوله: پرونده → شفاف‌سازی → نتیجه.
 *
 * سه مرحله‌ی ثابت، چون خط لوله سمت سرور هم سه مرحله دارد و ترتیبش قابل تغییر
 * نیست. نمایش مرحله به کاربر می‌گوید کجاست و چند گام مانده — بدون آن، انتظار
 * چندثانیه‌ای برای تماس LLM شبیه توقف به نظر می‌رسد.
 *
 * مرحله‌ی فعال حلقه‌ی هاله‌دار دارد و خطِ بین مراحل انجام‌شده گرادیانی می‌شود؛
 * پیشرفت باید در یک نگاه و بدون خواندن متن فهمیده شود.
 */

import { Check } from 'lucide-react'

import { cn } from '@/lib/cn'
import { fa } from '@/lib/format'

const STEPS = ['پرونده', 'شفاف‌سازی', 'نتیجه'] as const

interface StepsProps {
  /** نمایه‌ی مرحله‌ی جاری، از صفر. */
  current: number
}

export const Steps = ({ current }: StepsProps) => (
  <ol className="flex items-center gap-2.5" aria-label="مراحل مشاوره">
    {STEPS.map((label, index) => {
      const isDone = index < current
      const isActive = index === current
      return (
        <li key={label} className="flex items-center gap-2.5">
          <span
            className={cn(
              'flex items-center gap-2 text-xs transition-colors',
              isActive
                ? 'font-semibold text-ink'
                : isDone
                  ? 'text-ink-muted'
                  : 'text-ink-faint',
            )}
            aria-current={isActive ? 'step' : undefined}
          >
            <span
              className={cn(
                'grid size-7 place-items-center rounded-full text-[11px] font-semibold tabular-nums transition-all',
                isActive &&
                  'bg-linear-100 from-accent to-accent-two text-white shadow-glow ring-4 ring-accent/15',
                isDone && 'bg-support-soft text-support ring-1 ring-inset ring-support/30',
                !isActive && !isDone && 'bg-surface-sunken text-ink-faint ring-1 ring-inset ring-line',
              )}
              aria-hidden
            >
              {isDone ? <Check className="size-3.5" /> : fa(index + 1)}
            </span>
            <span className="hidden sm:inline">{label}</span>
          </span>
          {index < STEPS.length - 1 && (
            <span
              className={cn(
                'h-0.5 w-8 rounded-full transition-colors',
                isDone ? 'bg-linear-to-l from-support to-support/30' : 'bg-line',
              )}
              aria-hidden
            />
          )}
        </li>
      )
    })}
  </ol>
)
